import LogsHistory from './LogsHistory'
export default LogsHistory